import { Button, Input, Space, Typography, Upload, UploadFile, UploadProps, Modal, Progress } from "antd";
import { FC, useState } from "react";
import { API } from "../../api";
import { useStore } from "../../config/store";
import { IClean } from "../../config/types";
import { showProgressTextOnHeavyFiles } from "../../utils/progressUtils";

interface CommentBlockProps {
  submit: (text: string) => void;
  cancel: () => void;
  clean_id: any;
  rent_id: any;
}

export const CommentBlock: FC = () => {
  // export const CommentBlock: FC<CommentBlockProps> = ({ submit, cancel, clean_id, rent_id }) => {
  const [text, setText] = useState("");
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [uploading, setUploading] = useState(false);

  const { clean, cancelDrawer, progressPercent, setProgress, progressText, setProgressText } = useStore();
  const { date, cleantime, object, object_id, type, cost, rent_id, rent, comment, status, id } = clean as IClean;

  // const submitHandler = async () => {
  //   // await API.addComment({ text, clean_id });
  //   submit(text);
  // };

  const submitHandler = async () => {
    // await API.addComment({ text, clean_id });
    setUploading(true);
    showProgressTextOnHeavyFiles(fileList, setProgressText);
    await API.addComment({ text, clean_id: id, files: fileList, rent_id }, setProgress);
    setProgressText("");
    setUploading(false);
    cancelDrawer();
    // submit(text, fileList[0]);
  };

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file, files) => {
      console.log("🚀 ~ files:", files);
      setFileList([...fileList, ...files]);

      return false;
    },
    fileList,
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Modal
        open={uploading}
        closable={false}
        footer={null}
        width={'fit-content'}
      >
        <Space direction="vertical" align="center" size="large" style={{ width: "100%" }}>
          <Progress
            percent={progressPercent}
            type="circle"
          />

          {progressText && <Typography.Text style={{ whiteSpace: "break-spaces" }}>{progressText}</Typography.Text>}
        </Space>
      </Modal>
      <Input.TextArea
        autoSize={{ minRows: 5 }}
        placeholder="Напишите комментарий"
        onChange={(e) => setText(e.target.value)}
      />
      {/* <Upload action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload" listType="picture" maxCount={3} multiple>
        <Button>Upload</Button>
      </Upload> */}
      <Upload
        // action={`${URL}/api/files/clean/${cur?.rent?.id}`}
        {...props}
        // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
        listType="picture"
        style={{ width: "100%", display: "block" }}
        multiple
        // defaultFileList={fileList}
      >
        <Button
          block
          // icon={<UploadOutlined />}
        >
          Загрузить фото или видео
        </Button>
      </Upload>
      <Button
        type="primary"
        block
        size="large"
        disabled={text.length === 0}
        onClick={submitHandler}
        loading={uploading}
      >
        Отправить
      </Button>
      <Button block size="large" onClick={cancelDrawer} loading={uploading}>
        Отмена
      </Button>
    </Space>
  );
};
